import React, { useEffect } from 'react';
import '../App.css';
import HeroSection from '../containers/Hero/MainHeroSection';
import PressMarquee from '../componets/PressMarquee/PressMarquee';
import EventsDisplay from '../containers/EventsPreview/EventsDisplay';
import MusicPreview from '../containers/Music/MusicPreview';
import Subscribe from '../containers/Subscribe/Subscribe';
import AboutSection from '../containers/About/AboutSection';
import Footer from '../containers/Footer/Footer';

function Home() {
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <>
      <HeroSection />
      <PressMarquee />
      <EventsDisplay />
      <MusicPreview />
      <Subscribe />
      <AboutSection />
      <Footer />
    </>
  );
}

export default Home;
